import DocumentCreationButton from 'Components/DocumentCreationButton';
import { Item } from 'Components/Grid';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistoryRowListing from 'Components/HistoryRowListing';
import HistorySection from 'Components/HistorySection';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { formatPartialDate } from 'Utility/date';

const VEP = ({ documents, startEdit }: IOwnProps): React.JSX.Element => {
  return (
    <HistorySection
      headerText={<FormattedMessage id={'clinicalstudy.vep'} />}
      newButton={
        <DocumentCreationButton
          name="vep"
          text={'clinicalstudy.newvep'}
          onClick={startEdit({}, 'vep')}
          width={15}
          height={3}
          fontSize={14}
          alternate={true}
        />
      }
    >
      <HistoryRowListing
        documents={documents}
        headers={
          <>
            <Item xs={2}>
              <FormattedMessage id={'general.date'} />
            </Item>
            <Item xs={8} />
          </>
        }
        contentFormat={d => (
          <>
            <Item xs={2} style={{ fontWeight: '600' }}>
              {formatPartialDate(d.date)}
            </Item>
            <Item xs={7} />
            <Item xs={3}>
              <HistoryRowControls document={d} startEdit={startEdit} />
            </Item>
          </>
        )}
      />
    </HistorySection>
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'vep'>[];
  startEdit: StartEdit;
}

export default VEP;
